import { useState, useEffect } from "react";
import { DLSModal } from "~/components/shared/Modals/Modal";
import { SUBSCRIPTION_STATUS } from "~/constants/subscriptionStatus";
import { useQuizState } from "~/hooks/useQuizState";

const CLUB_ORDERS_PATH = "/a/sub/club-orders";

export function AlreadyUsedIntroOrderModal() {
  const { session: { subscriptionStatus, customerId } } = useQuizState();
  const [showAlreadyUsedIntroOrder, setShowAlreadyUsedIntroOrder] =
    useState(false);

  /**
   * Effect to handle the display of a notification about the use of an introductory order.
   *
   * The notification is shown if the user meets either of the following conditions:
   * 1. The user is logged in and has placed an introductory order.
   * 2. The user's membership status is 'active'.
   */
  useEffect(() => {
    if (
      customerId &&
      subscriptionStatus !== SUBSCRIPTION_STATUS.NEVER_SUBSCRIBED
    ) {
      setShowAlreadyUsedIntroOrder(true);
    }
  }, [customerId, subscriptionStatus]);

  const hideModal = () => {
    if (typeof window !== "undefined") {
      window.location.href = `${window.location.origin}${CLUB_ORDERS_PATH}`;
    }
    setShowAlreadyUsedIntroOrder(false);
  };

  return (
    <DLSModal
      title="Introductory offer already used"
      position={["center", "center"]}
      show={showAlreadyUsedIntroOrder}
      onHide={hideModal}
      primary={{ onClick: hideModal, label: "Continue", theme: "v2" }}
      data-testid="wine-change-modal"
    >
      <p>Looks like you already used our introductory offer.</p>
    </DLSModal>
  );
}
